var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F3F3F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3385 25.8333C28.3385 26.2754 28.1629 26.6993 27.8504 27.0118C27.5378 27.3244 27.1139 27.5 26.6719 27.5H13.3385C12.8965 27.5 12.4726 27.3244 12.16 27.0118C11.8475 26.6993 11.6719 26.2754 11.6719 25.8333V14.1667C11.6719 13.7246 11.8475 13.3007 12.16 12.9882C12.4726 12.6756 12.8965 12.5 13.3385 12.5H17.5052L19.1719 15H26.6719C27.1139 15 27.5378 15.1756 27.8504 15.4882C28.1629 15.8007 28.3385 16.2246 28.3385 16.6667V25.8333Z",
    stroke: "#494656",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessages);
export default __webpack_public_path__ + "static/media/messages.a6c4c7289deb96a706bf3c400fb793e1.svg";
export { ForwardRef as ReactComponent };